import React from "react";
// import SettingItem from "./SettingItem";
// import { useTheme } from "../../../providers/ThemeProvider";
import { SettingsToggle } from "./SettingsToggle";
import { SettingsSelect } from "./SettingsSelect";
import { Icon } from "../../../components/icons/Icon";
import { blankIcon } from "../../../components/icons/appIcons";

// ============================================================
// CategorySection: renders a category and its settings list
// ============================================================
export default React.memo(function SettingsCategory({
  category,
  settings,
  onUpdate,
}) {
  return (
    <section id={`category-${category.label}`} className="settings-group">
      <div className="settings-header">
        <h2>{category.label}</h2>
      </div>
      <div className="settings-list-container">
        <ul className="settings-list">
          {settings.length === 0 ? (
            <li className="settings-item">
              <span>No settings in this category.</span>
            </li>
          ) : (
            <>
              {settings.map((setting) => {
                const isSelect = setting.type === "select";
                return (
                  <li className="settings-item">
                    <div className="settings-left-content">
                      {!setting.image ? (
                        <></>
                      ) : (
                        <span className="settings-icon">
                          <Icon icon={setting.image} />
                        </span>
                      )}
                      <span className="settings-label">{setting.label}</span>
                    </div>
                    <div className="settings-right-content">
                      {isSelect ? (
                        <SettingsSelect
                          key={setting.id}
                          id={`setting-${setting.id}`}
                          setting={setting}
                          onSettingChange={(updated) =>
                            onUpdate(updated.id, updated.value)
                          }
                          // onSettingChange={handleItemChange}
                        />
                      ) : (
                        <SettingsToggle
                          key={setting.id}
                          id={`setting-${setting.id}`}
                          setting={setting}
                          // disabled={disabledAll || !!savingKeys[setting.id]}
                          onSettingChange={(updated) =>
                            onUpdate(updated.id, updated.value)
                          }
                        />
                      )}
                    </div>
                  </li>
                );
              })}
            </>
          )}
        </ul>
      </div>
    </section>
  );
});
